export default class Shape {
    x = undefined;
    y = undefined;
    constructor() {
        this.x = undefined;
        this.y = undefined;
    }
    collidesWith(shape: Shape) {
        let axes = this.getAxes() as any;
        axes = axes.concat(shape.getAxes());
        return !this.separationOnAxes(axes, shape);
    }

    separationOnAxes(axes: any, shape: any) {
        for (let i = 0, len = axes.length; i < len; i++) {
            const axis = axes[i];
            const projection1 = shape.project(axis);
            const projection2 = this.project(axis);

            if (!projection1.overlaps(projection2)) {
                return true;
            }
        }
        return false;
    }
    project(axis: any) {
        throw 'project(axis) not implemented';
    }

    getAxes() {
        throw 'getAxes() not implemented';
    }
}
